import React from 'react';
import '../../scss/components/LogoutLink.scss';
import LogOutIcon from "../../img/inline/LogOutIcon.tsx";

import { useAuthContext } from '../../features/auth/hooks/use-auth-context.ts';

const LogoutLink = ({
    icon,
}) => {
    const { logout } = useAuthContext();
    const onClick = async (e) => {
        e.preventDefault();
        logout();
    }

    return (
        <button className="logout" onClick={onClick}>{icon ? <LogOutIcon /> : ''}Ausloggen</button>
    )
}

export default LogoutLink;